import { render, staticRenderFns } from "./importdata-wo.vue?vue&type=template&id=75459a14&scoped=true&"
import script from "./importdata-wo.vue?vue&type=script&lang=js&"
export * from "./importdata-wo.vue?vue&type=script&lang=js&"
import style0 from "./importdata-wo.vue?vue&type=style&index=0&id=75459a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75459a14",
  null
  
)

export default component.exports